var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkbox", class: _vm.containerClass }, [
    _c(
      "div",
      {
        staticClass: "checkbox-input-container",
        class: { "add-check-svg": _vm.value, checked: _vm.value }
      },
      [
        _c("input", {
          attrs: { type: "checkbox", name: _vm.name, id: _vm.name },
          domProps: { checked: _vm.value },
          on: { change: _vm.onChange }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "checkbox-label-container" },
      [
        _c(
          "label",
          { staticClass: "checkbox-label", attrs: { for: _vm.name } },
          [_vm._v(" \n      " + _vm._s(_vm.label) + "\n    ")]
        ),
        _vm._v(" "),
        _vm._t("default")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e92c207", { render: render, staticRenderFns: staticRenderFns })
  }
}